import React from 'react'
import { Ratio } from 'react-bootstrap'
import styles from './index.module.css'
import { useDispatch,useSelector } from 'react-redux'
import { setBtnselS } from '../../store/modules/btnsel'
import { setBtnrecS } from '../../store/modules/btnrec'
import { darkenColor } from '../../utils/publicfunction'


export default function Btnnum(props) {
  const { nu }=props
  const {b}=useSelector((state)=>state.btnsel)
  const {p}=useSelector((state)=>state.pencil)
  const {c}=useSelector((state)=>state.palette)
  const {r}=useSelector((state)=>state.btnrec)

  // 数字键背景色和选中的框线
  const {bnu}=useSelector((state)=>state.colorplate);
  const darkenedColor = darkenColor(bnu, 0.5);
  const buttonStyle = {
    boxShadow: 'none',
    transform: 'scale(1.2)',
    border: `8px solid ${darkenedColor}`,
    position: 'relative',
    zIndex: 1
  };
  const buttonBgStyle = {backgroundColor:bnu}

  // 单元格背景色
  const {ce}=useSelector((state)=>state.colorplate);
  const bgcell={
    backgroundColor:ce['b'+nu]
  }

  // 候选数背景色
  const {hx}=useSelector((state)=>state.colorplate);
  const bghxA={
    backgroundColor:hx['a'+c]
  }
  const bghxB={
    backgroundColor:hx['b'+c]
  }

  const bt= b===nu ? {...buttonStyle,...buttonBgStyle} : buttonBgStyle
  const ca= b===nu ? "d-black" : "d-none"
  const dispatch=useDispatch()

  let bn="d-none";let sn="d-none";
  let bc="d-none";let sc="d-none";
  if(!p && c===0){
    bn="d-black";sn="d-none";bc="d-none";sc="d-none";
  }
  if(p && c===0){
    bn="d-none";sn="d-black";bc="d-none";sc="d-none";
  }
  if(!p && c!==0){
    bn="d-none";sn="d-none";bc="d-black";sc="d-none";
  }
  if(p && c!==0){
    bn="d-none";sn="d-none";bc="d-none";sc="d-black";
  }
  const ab= r===0 ? "d-black" : "d-none"
  const ba= r===0 ? "d-none" : "d-black"

  const setselandrec=()=>{
    if(b===nu){
      let h=r
      h=++h%2
      dispatch(setBtnrecS(h))
    }else{
      dispatch(setBtnselS(nu))
    }
  };

  return (
    <Ratio aspectRatio={"1x1"}>
    <div onClick={setselandrec}>
      <div
        className={`${styles.b_n_adiv}`}
        style={bt}
      >

        <div className={`${styles.b_n_bignum} ${bn}`}>
          <img src={`./pic/${nu}-square.svg`} alt="" />
        </div>

        <div className={`${styles.b_n_smlnum} ${sn}`}>
          <img src={`./pic/${nu}-circle.svg`} alt="" />
        </div>
        
        <div className={`${styles.b_n_bgcolor} ${bc}`}>
          <div className={styles[`bg_c${nu}`]} style={bgcell}></div>
        </div>

        <div className={`${styles.b_n_smlcolor} ${sc}`}>
        {/* bg_a${c} */}
          <div className={`${styles.b_n_smc} ${ab}`}>
            <div className={`${styles.sm_a}`} style={bghxA}>
              <img src={`./pic/${nu}-circle.svg`} alt=""/>
            </div>
            <div className={`${styles.sm_b}`} style={bghxB}></div>
          </div>

          <div className={`${styles.b_n_smc} ${ba}`}>
            <div className={`${styles.sm_b}`} style={bghxA}></div>
            <div className={`${styles.sm_a}`} style={bghxB}>
              <img src={`./pic/${nu}-circle.svg`} alt=""/>
            </div>
          </div>
          <div className={`${styles.sm_c} ${ca}`}>
              <img src='./pic/caret.svg' alt=''/>
          </div>

        </div>
      </div>
    </div>
    </Ratio>
  )
}
